import { grey, teal } from "@mui/material/colors";

export const commitmentsColors = {
  sp: teal[300],
  ri: "#2196F3",
  onDemand: grey[400],
};
